import ButtonWithLink from '@gameday/react-components/components/ButtonWithLink'

import gameDaySvg from '../../../../assets/images/game_day.svg'
import commonStyles from '../../../../styles/common-styles.module.scss'

function ErrorPage({ errorMessage, errorDescription, hideBackToLogin, logOutRequest }) {
  return (
    <div className={commonStyles.splashPageContainer}>
      <div className={commonStyles.contentContainer}>
        <img style={{ marginBottom: 40 }} src={gameDaySvg} alt="Gameday" />
        <h2>{errorMessage}</h2>
        {errorDescription && <h3>{errorDescription}</h3>}
        {!hideBackToLogin && (
          <ButtonWithLink
            id="submit-button"
            type="submit"
            onClick={logOutRequest}
            label="Go back to Login"
            color="primary"
            variant="contained"
            style={{ marginTop: 30 }}
          />
        )}
      </div>
    </div>
  )
}

ErrorPage.defaultProps = {
  errorMessage: 'Oops! Something went wrong',
  errorDescription: null,
  hideBackToLogin: false,
}

export default ErrorPage
